import { render, staticRenderFns } from "./submit-success.vue?vue&type=template&id=2d2b2d95&scoped=true&"
import script from "./submit-success.vue?vue&type=script&lang=js&"
export * from "./submit-success.vue?vue&type=script&lang=js&"
import style0 from "./submit-success.vue?vue&type=style&index=0&id=2d2b2d95&scoped=true&lang=css&"
import style1 from "./submit-success.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b2d95",
  null
  
)

export default component.exports